<template>
  <transition name="btt">
    <button v-show="visible" type="button" class="btt" aria-label="Volver arriba" @click="scrollTop">
      <span class="material-symbols-outlined">arrow_upward</span>
    </button>
  </transition>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";

const visible = ref(false);

const onScroll = () => {
  visible.value = window.scrollY > 400;
};

const scrollTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

onMounted(() => window.addEventListener("scroll", onScroll, { passive: true }));
onUnmounted(() => window.removeEventListener("scroll", onScroll));
</script>

<style scoped>
.btt {
  position: fixed;
  right: 24px;
  bottom: calc(24px + env(safe-area-inset-bottom, 0px));
  z-index: 1000;
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  border: 1px solid var(--sd-border);
  border-radius: 50%;
  background: var(--sd-surface);
  box-shadow: var(--sd-shadow-lg);
  cursor: pointer;
  transition: transform 0.2s, background 0.2s;
}

.btt:hover {
  transform: translateY(-3px);
  background: var(--sd-primary);
}

.btt .material-symbols-outlined {
  font-size: 24px;
  color: var(--sd-primary);
}

.btt:hover .material-symbols-outlined {
  color: var(--sd-primary-contrast);
}

.btt-enter-active,
.btt-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.btt-enter,
.btt-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

@media (max-width: 640px) {
  .btt {
    right: 16px;
    width: 44px;
    height: 44px;
  }
}
</style>
